import { useContext } from "react";
import { ScoreboardContext } from "../context/context";

export const useScoreboardContext = () => {
  const context = useContext(ScoreboardContext);
  return context;
};
